//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { Alert } from '@components/atoms/alert/Alert';
import { RequestError } from '@utils/sessionFetch';

interface SamplingCampaignQueryErrorAlertProps {
  error?: RequestError;
  message?: string;
}

export const SamplingCampaignQueryErrorAlert = ({
  error,
  message,
}: SamplingCampaignQueryErrorAlertProps) => {
  if (error?.statusCode === 403) {
    return (
      <Alert type='error'>
        You don't have access to this feature. Contact your Account Manager for
        more information.
      </Alert>
    );
  }

  return (
    <Alert type='error'>
      {message ?? 'An unexpected error occurred. Please try again later.'}
    </Alert>
  );
};
